'use strict';

L.Circle = L.Circle.extend({
  /**
   * override
   * We want the radius stored on the `properties` property
   */
  toGeoJSON: function () {
    var geoJSON = L.GeoJSON.getFeature(this, {
      type: 'Point',
      coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
    });

    L.extend(geoJSON.properties, {
      radius: this.getRadius()
    });

    return geoJSON;
  }
});


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/leaflet/GeoJSON.js